module.exports = __webpack_public_path__ + "media/images/contest_voter_campaigns/steps-phone@3x-9128be705513169089e41d28678e2bd7.png";